import { useNavigate } from "react-router-dom";
import "./errortienda.css";

export default function ErrorTienda() {
  const navigate = useNavigate();
 
  return (
    <div className="errortienda-page">
      <div className="errortienda-inner">
        <div className="errortienda-badge">CYRAVI</div>

        <div className="errortienda-card">
          <div className="errortienda-card-line" />

          <div className="errortienda-icon-wrap" aria-hidden="true">
            <div className="errortienda-icon-ring">
              <svg
                className="errortienda-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 9.5 12 4l9 5.5" />
                <path d="M5 10.5V19a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8.5" />
                <path d="M9 20v-5h6v5" />
                <path d="M10.5 8.75h3" />
              </svg>
            </div>
          </div>

          <span className="errortienda-eyebrow">Tienda no disponible</span>

          <h1 className="errortienda-title">No encontramos esta tienda</h1>

          <p className="errortienda-text">
            La tienda que intentas abrir no existe en esta dirección o no está
            disponible por ahora. Verifica el enlace o intenta nuevamente más
            tarde.
          </p>

          <div className="errortienda-actions">
            <button
              type="button"
              className="errortienda-btn errortienda-btn--primary"
              onClick={() => navigate("/")}
            >
              Ir al inicio
            </button>

            <button
              type="button"
              className="errortienda-btn errortienda-btn--ghost"
              onClick={() => window.location.reload()}
            >
              Intentar de nuevo
            </button>
          </div>
        </div>

        <div className="errortienda-footer">by cyravi</div>
      </div>
    </div>
  );
}